module.exports = __webpack_public_path__ + "img/henson-in-iowa.ff2f0201.png";